import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { officeWordHands } from "./hands/word";
import type { DocumentHands } from "./hands/types";
import { REQUIRED_WORD_API, wordApiSupported } from "./office";
import { PairingSession } from "./session";
import { App, debugFromLocation } from "./ui/App";
import "./ui/styles.css";

function mount(host: Office.HostType | null): void {
  let hands: DocumentHands | null = null;
  let problem: string | null = null;
  if (host !== Office.HostType.Word) {
    problem = "Open this pane from Word to use Ella.";
  } else if (!wordApiSupported(REQUIRED_WORD_API)) {
    problem = `This version of Word is too old for Ella (it needs Word API ${REQUIRED_WORD_API}: Microsoft 365, Office 2024, or Word on the web).`;
  } else {
    hands = officeWordHands();
  }
  const root = document.getElementById("root");
  if (root === null) return;
  const session = new PairingSession();
  createRoot(root).render(
    <StrictMode>
      <App session={session} hands={hands} handsProblem={problem} debug={debugFromLocation()} />
    </StrictMode>,
  );
  if (hands !== null) void session.restore();
}

if (typeof Office !== "undefined") {
  void Office.onReady((info) => mount(info.host ?? null));
} else {
  // Loaded outside Office (office.js failed to load): render the explanation only.
  const root = document.getElementById("root");
  if (root !== null) root.textContent = "Open this pane from Microsoft Word to use Ella.";
}
